import { init } from 'shareon';

const start = () => {
  init();
};

export default { start };
